import app from 'flarum/forum/app';
const EMPTY_FIELD = {
  enabled: false,
  required: false,
  label: null,
  placeholder: null
};
export const EMPTY_CONFIG = {
  enabled: false,
  showInNavigation: false,
  navLabel: null,
  title: null,
  description: null,
  successMessage: null,
  customCss: null,
  accessMode: 'disabled',
  allowGuestSubmissions: false,
  allowRegisteredSubmissions: false,
  requireEmailVerification: false,
  prefillAuthenticated: false,
  categories: [],
  fields: {
    name: {
      ...EMPTY_FIELD
    },
    email: {
      ...EMPTY_FIELD
    },
    subject: {
      ...EMPTY_FIELD
    },
    message: {
      ...EMPTY_FIELD
    },
    category: {
      ...EMPTY_FIELD
    },
    phone: {
      ...EMPTY_FIELD
    },
    privacy: {
      ...EMPTY_FIELD
    }
  },
  messageMinLength: 1,
  messageMaxLength: 5000,
  subjectMaxLength: 150,
  privacyUrl: null,
  turnstile: {
    enabled: false,
    siteKey: null,
    theme: 'auto',
    appearance: 'always'
  }
};

/**
 * Reads the whitelisted server-side config. Falls back to a disabled form if
 * the attribute is missing (for example with a stale cached page).
 */
export function getContactPageConfig() {
  const raw = app.forum.attribute('contactPageConfig');
  if (!raw || typeof raw !== 'object') {
    return EMPTY_CONFIG;
  }
  return {
    ...EMPTY_CONFIG,
    ...raw,
    customCss: typeof raw.customCss === 'string' && raw.customCss.trim() !== '' ? raw.customCss : null,
    categories: Array.isArray(raw.categories) ? raw.categories.filter(category => typeof category === 'string') : [],
    fields: {
      ...EMPTY_CONFIG.fields,
      ...(raw.fields ?? {})
    },
    turnstile: {
      ...EMPTY_CONFIG.turnstile,
      ...(raw.turnstile ?? {})
    }
  };
}
export function denialKey(config, user = app.session.user ?? null) {
  if (!config.enabled || config.accessMode === 'disabled') {
    return 'cengizkemec-contact-page.forum.access.disabled';
  }
  if (!['everyone', 'registered', 'guests'].includes(config.accessMode)) {
    return 'cengizkemec-contact-page.forum.access.disabled';
  }
  if (!user) {
    if (!['everyone', 'guests'].includes(config.accessMode)) {
      return 'cengizkemec-contact-page.forum.access.guests_not_allowed';
    }
    if (!config.allowGuestSubmissions) {
      return 'cengizkemec-contact-page.forum.access.guest_submissions_disabled';
    }
    return null;
  }
  if (config.accessMode === 'guests') {
    return 'cengizkemec-contact-page.forum.access.registered_not_allowed';
  }
  if (!config.allowRegisteredSubmissions) {
    return 'cengizkemec-contact-page.forum.access.registered_submissions_disabled';
  }
  if (config.requireEmailVerification && !user.isEmailConfirmed()) {
    return 'cengizkemec-contact-page.forum.access.email_verification_required';
  }
  return null;
}
export function canUseContactPage(config, user = app.session.user ?? null) {
  return denialKey(config, user) === null;
}
export function fieldLabel(config, field) {
  const custom = config.fields[field].label;
  return custom || app.translator.trans(`cengizkemec-contact-page.forum.fields.${field}_label`, {}, true);
}
export function fieldPlaceholder(config, field) {
  const custom = config.fields[field].placeholder;
  return custom || app.translator.trans(`cengizkemec-contact-page.forum.fields.${field}_placeholder`, {}, true);
}
flarum.reg.add('cengizkemec-contact-page', 'common/config', { EMPTY_CONFIG: EMPTY_CONFIG,getContactPageConfig: getContactPageConfig,denialKey: denialKey,canUseContactPage: canUseContactPage,fieldLabel: fieldLabel,fieldPlaceholder: fieldPlaceholder, });